import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaChartBar, FaSignOutAlt } from "react-icons/fa";
import "./AdminNavbar.css";

export default function AdminNavbar() {
  return (
    <nav className="admin-navbar">
      <h2 className="logo-admin">ATPL Admin</h2>
     <ul className="nav-links-admin">
  <li>
    <Link to="/dashboard">
      <FaUsers /> Dashboard
    </Link>
  </li>
  {/* EVENTS MENU */}
  <li className="dropdown">
    <span className="dropdown-title">
      <FaChartBar /> Events
    </span>

    <ul className="submenu">
      <li>
        <Link to="/Dec2025_Womens_T20-report">
          Women’s T20 Premier League
        </Link>
      </li>

      <li>
        <Link to="/Men'sT20">
          Men’s T20 Premier League
        </Link>
      </li>
    </ul>
  </li>

  <li>
    <Link to="/usermanagement">
      <FaUsers /> Users
    </Link>
  </li>

  <li>
    <Link to="/report">
      <FaChartBar /> Reports
    </Link>
  </li>

  

  <li>
    <Link
      to="/admin"
      onClick={() => {
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("adminUser");
        window.location.href = "/admin";
      }}
    >
      <FaSignOutAlt /> Logout
    </Link>
  </li>
</ul>

    </nav>
  );
}
